import DataViewerSetup from './dataViewer/PluginSetup';
import ActionsSetup from './actions/PluginSetup';
import BlueprintsSetup from './blueprint/PluginSetup';
import FormsSetup from './forms/PluginSetup';
import AttributesSetup from './attributes/PluginSetup';
import PairingPlugin from './details/PluginSetup';
import MapSetup from './map/PluginSetup';
import ColorizerSetup from './colorizer/PluginSetup';
import BulkCreateSetup from './bulkCreate/PluginSetup';
import BulkUpdateSetup from './bulkUpdate/PluginSetup';
import DashboardSetup from './dashboard/PluginSetup';
import AlertsSetup from './alerts/PluginSetup';
import ErrorsSetup from './errors/PluginSetup';
import GroupScreenSetup from './groupscreen/PluginSetup';
import BillingSetup from './billing/PluginSetup';
import JobsPluginSetup from './jobs/PluginSetup';
import BatteryAlertsSetup from './batteryAlerts/PluginSetup';
import GeoTiles from './geotiles/PluginSetup';
import SearchUsers from './searchUsers/PluginSetup';
import QueryTriggers from './queryTrigger/PluginSetup';
import DeviceHealth from './deviceHealth/PluginSetup';
import LocatorAlerts from './locatorAlerts/PluginSetup';
import LocatorPayloadColumns from './locatorPayloadColumns/PluginSetup';
import NavLogoBlocker from './blockerHook/PluginSetup';
import BillingPortalSetup from './billingPortal/PluginSetup';
export default {
  install: async molten => {
    // Analyzers.install( molten )
    DataViewerSetup.install(molten);
    ActionsSetup.install(molten);
    BlueprintsSetup.install(molten);
    FormsSetup.install(molten);
    AttributesSetup.install(molten);
    PairingPlugin.install(molten);
    MapSetup.install(molten);
    ColorizerSetup.install(molten);
    BulkCreateSetup.install(molten);
    BulkUpdateSetup.install(molten);
    DashboardSetup.install(molten);
    AlertsSetup.install(molten);
    ErrorsSetup.install(molten);
    GroupScreenSetup.install(molten);
    BillingSetup.install(molten);
    JobsPluginSetup.install(molten);
    BatteryAlertsSetup.install(molten);
    GeoTiles.install(molten);
    SearchUsers.install(molten);
    QueryTriggers.install(molten);
    DeviceHealth.install(molten);
    LocatorAlerts.install(molten);
    LocatorPayloadColumns.install(molten);
    NavLogoBlocker.install(molten);
    BillingPortalSetup.install(molten);
  }
};